import React from 'react';
import { DeviationTypes } from '../../../types/deviation';
import { getDeviationType } from '../../_helpers';
import PollThumb from './Poll';
import StatusThumb from './Status';
import DefaultThumb from './Default';
import TierThumb from './Tier';
const StandardThumb = (props)=>{
    const type = getDeviationType(props.deviation);
    switch(type){
        case DeviationTypes.POLL:
            return /*#__PURE__*/ React.createElement(PollThumb, props);
        case DeviationTypes.STATUS:
            return /*#__PURE__*/ React.createElement(StatusThumb, props);
        case DeviationTypes.TIER:
            return /*#__PURE__*/ React.createElement(TierThumb, props);
        default:
            return /*#__PURE__*/ React.createElement(DefaultThumb, props);
    }
};
StandardThumb.displayName = 'StandardThumb';
export default StandardThumb;

//# sourceMappingURL=Standard.js.map